(() => {
  function initialise(root = document) {
    root.querySelectorAll('[data-hc-section]').forEach(section => {
      if (section.dataset.hcReady) return;
      section.dataset.hcReady = 'true';
      const main = section.querySelector('.hc-main-image');
      const thumbs = [...section.querySelectorAll('[data-hc-thumb]')];
      const previous = section.querySelector('[data-hc-previous]');
      const next = section.querySelector('[data-hc-next]');
      const count = section.querySelector('[data-hc-image-index]');
      const rail = section.querySelector('.hc-thumbs');
      let currentIndex = 0;
      function selectImage(index) {
        if (!main || !thumbs[index]) return;
        currentIndex = index;
        const button = thumbs[index];
        main.src = button.dataset.src;
        main.srcset = [400, 600, 900, 1200, 1400].map(width => {
          const url = new URL(button.dataset.src, location.href);
          url.searchParams.set('width', width);
          return `${url.href} ${width}w`;
        }).join(', ');
        main.alt = button.dataset.alt;
        thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
        if (count) count.textContent = String(index + 1);
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === thumbs.length - 1;
        if (rail) {
          const offset = button.getBoundingClientRect().left - rail.getBoundingClientRect().left;
          rail.scrollTo({left: rail.scrollLeft + offset - (rail.clientWidth - button.clientWidth) / 2, behavior: 'auto'});
        }
      }
      thumbs.forEach((button, index) => button.addEventListener('click', () => selectImage(index)));
      if (previous) previous.addEventListener('click', () => selectImage(currentIndex - 1));
      if (next) next.addEventListener('click', () => selectImage(currentIndex + 1));
      section.querySelectorAll('[data-bh-offer]').forEach(radio => radio.addEventListener('change', () => {
        const url = new URL(location.href);
        url.searchParams.set('variant', radio.value);
        history.replaceState({}, '', url);
      }));
      section.querySelectorAll('[data-hc-compare]').forEach(compare => {
        compare.querySelector('input').addEventListener('input', event => compare.style.setProperty('--hc-position', `${event.target.value}%`));
      });
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
